import React from "react";

// CrewZNatioN — canonical editorial brand token.
//
// Renders the canonical spelling `CrewZNatioN` in bold (weight 800),
// preserving the surrounding paragraph's font family, size, color,
// line-height, and alignment. Weight 800 was chosen so the token is
// at least as heavy as every editorial context on the site (light
// bodies at 300, running text at 400, and `.overline-primary` at
// 800), never appearing thinner than its surroundings.
// `dir="ltr"` isolates the Latin token so Arabic RTL paragraphs keep
// correct punctuation attachment and glyph ordering around the brand
// name.
//
// Use `<Brand />` in place of any raw editorial occurrence of the
// brand name in JSX text. Do NOT use inside URLs, filenames, alt
// text, code identifiers, or any non-editorial technical string —
// those must remain plain-text.
export default function Brand() {
    return (
        <strong dir="ltr" style={{ fontWeight: 800, textTransform: "none" }}>
            CrewZNatioN
        </strong>
    );
}
